<template>
  <div class="site-wrapper">
    <Header></Header>
    <div class="mine-wrap">
      <div class="content-wrap w1200">
        <div class="side-tab">
          <div class="side-group" v-for="(item, index) in sideTabs" :key="index">
            <router-link :to="{ path: item.url }" :class="[{ 'side-active': path == item.url }, 'side-item']">
              {{ item.name }}
            </router-link>
            <router-link :to="{ path: child.url }" :class="[{ 'side-active': path == child.url }, 'side-item']"
              v-for="child in item.children" :key="child.url">
              {{ child.name }}
            </router-link>
          </div>
        </div>
        <div class="info-wrap">
          <div class="userInfo-wrap">
            <img :src="user.avatar" class="avatar" alt="" />
            <div class="info">
              <div class="user-info">
                <span class="username">{{ user.name }}</span>
                <span class="phone">{{ user.phone }}</span>
              </div>
              <div class="level-info">
                <div class="level-name">{{ user.rank_name }}</div>
                <div class="progress-wrap">
                  <div class="progress-line">
                    <div class="progress" :style="{ width: percent + '%' }"></div>
                  </div>
                  <div class="exp-info">
                    <p>{{ user.exp }}/{{ nextRank.basic_exp }}</p>
                    <p>升级{{ nextRank.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { getIndex } from "@/api/user";
import Header from "@/components/header";
import Footer from "@/components/footer";
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      sideTabs: [
        {
          name: "账号管理",
          url: "/user",
          children: [
            {
              name: "我的资产",
              url: "/user/index",
            },
            {
              name: "个人资料",
              url: "/user/profile",
            },
            {
              name: "成为伙伴",
              url: "/user/join",
            },
            {
              name: "我的积分",
              url: "/user/integral",
            },
            {
              name: "推荐有礼",
              url: "/user/recommend",
            },
            {
              name: "优惠券",
              url: "/user/coupon",
            },
          ],
        },
        {
          name: "订单管理",
          url: "/user/order/index",
          children: [
            {
              name: "项目订单",
              url: "/user/order/list/project",
            },
            {
              name: "服务订单",
              url: "/user/order/list/service",
            },
            {
              name: "商城订单",
              url: "/user/order/list/store",
            },
          ],
        },
        {
          name: "发票管理",
          url: "/invoice",
          children: [
            {
              name: "等待开票",
              url: "/invoice/apply",
            },
            {
              name: "开票信息",
              url: "/invoice/header",
            },
            {
              name: "我的发票",
              url: "/invoice/index",
            },
          ],
        },
        {
          name: "我的团队",
          url: "/team",
          children: [
            {
              name: "团队主页",
              url: "/team/index",
            },
          ],
        },
        {
          name: "其他功能",
          url: "/user/feedback",
        },
        {
          name: "常见问题",
          url: "/user/faq",
        },
      ],
      leaderMenu: [
        {
          name: "团队中心",
          url: "/team/center/member",
        },
        {
          name: "团队订单",
          url: "/team/order/list",
        },
        {
          name: "团队申请",
          url: "/team/apply",
        },
      ],
      user: {},
      nextRank: {},
      percent: 0,
    };
  },
  computed: {
    ...mapGetters(["path"])
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex({}).then(res => {
        this.loading = false;
        this.user = res.data.user;
        if (res.data.user.team_role > 0) {
          const teamIndx = this.sideTabs.findIndex((item) => item.name == '我的团队')
          this.sideTabs[teamIndx].children.push(...this.leaderMenu);        
        }
        this.nextRank = res.data.nextRank;
        this.percent = res.data.percent;
      }).catch((err) => {

      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mine-wrap {
  width: 100%;
  background-color: #f4f8f9;
  padding-top: 35px;
  padding-bottom: 415px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;

  .content-wrap {
    display: grid;
    grid-template-columns: 180px auto;
    column-gap: 20px;

    .side-tab {
      width: 100%;
      height: fit-content;
      padding: 13px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-direction: column;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
      border-radius: 2px 2px 2px 2px;

      .side-item {
        width: 180px;
        height: 37px;
        font-size: 16px;
        font-weight: 300;
        color: #a0a9ac;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .side-group {
        .side-item {
          &:first-child {
            font-weight: bold !important;
            color: #222222 !important;
          }
        }

        .side-active {
          background: #00b4e8;
          font-size: 16px;
          font-weight: 300;
          color: #ffffff !important;

          &:first-child {
            color: #ffffff !important;
          }
        }
      }
    }

    .info-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;

      .userInfo-wrap {
        width: 100%;
        padding: 19px 48px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        column-gap: 32px;
        background: linear-gradient(40deg, #82a7b3 0%, #012e3b 100%);
        box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
        border-radius: 2px 2px 2px 2px;

        .avatar {
          width: 74px;
          height: 74px;
          background: #ebf1f3;
          border: 1px solid #ffffff;
          border-radius: 50%;
        }

        .info {
          display: flex;
          flex-direction: column;
          row-gap: 20px;

          .user-info {
            font-size: 16px;
            font-weight: 400;
            color: #895c38;

            .username {
              margin-right: 10px;
            }
          }

          .level-info {
            display: flex;
            align-items: center;
            column-gap: 10px;

            .level-name {
              font-size: 14px;
              font-weight: 400;
              color: #fae2b4;
              padding: 5px 16px;
              background: #cf993f;
              border-radius: 13px;
            }

            .progress-wrap {
              width: 135px;
              display: flex;
              align-items: center;
              flex-direction: column;
              row-gap: 6px;

              .progress-line {
                width: 135px;
                height: 4px;
                border-radius: 4px;
                position: relative;
                background-color: #fae2b4;

                .progress {
                  position: absolute;
                  z-index: 1;
                  top: 0;
                  left: 0;
                  height: 4px;
                  background-color: #cf993f;
                  border-radius: 4px;
                }
              }

              .exp-info {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                font-weight: 300;
                color: #292523;
              }
            }
          }
        }
      }
    }
  }
}
</style>
